import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from '@/store'
import { setInternalEffectRecipeOutput } from '@/store/fullLayering'

import InternalEffectTooltip from './components/InternalEffectTooltip'

const KonvaInternalEffect = () => {
  const dispatch = useDispatch()
  const internalEffect = useAppSelector(
    (state) => state.fullLayering.internalEffects,
  )
  const internalEffectOutput = useAppSelector(
    (state) => state.fullLayering.internalEffectOutput,
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )

  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}
    Object.keys(internalEffect?.[canvasImage?.id] || {}).forEach((key) => {
      initialTooltipState[key] = true
    })
    setTooltipOpenMap(initialTooltipState)
  }, [internalEffect, canvasImage?.id])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteInternalEffect = useCallback(
    (key: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setInternalEffectRecipeOutput({
          imageId: canvasImage?.id,
          key: key,
          result: undefined,
        }),
      )
    },
    [dispatch, canvasImage?.id],
  )
  return (
    <>
      {Object.keys(internalEffect?.[canvasImage?.id] || {}).map((key) => {
        const data = internalEffect?.[canvasImage?.id]?.[key]
        const output = internalEffectOutput?.[canvasImage?.id]?.[key]
        if (!data?.output || !output) return null
        return (
          <InternalEffectTooltip
            key={key}
            keyName={key}
            data={data}
            output={output}
            open={!!tooltipOpenMap[key]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            onDelete={handleDeleteInternalEffect}
          />
        )
      })}
    </>
  )
}

export default KonvaInternalEffect
